/**
 * 动态路由标题配置
 *
 * 重要：配置顺序必须从最长路径到最短路径
 * 避免 /orders/:id/devices/:deviceId 被 /orders/:id 误匹配
 */

import { DynamicRouteConfig } from '@/types/menu'
import {
  Package,
  User,
  Building,
  Wrench,
  ClipboardList,
  Truck,
} from 'lucide-react'

export const DYNAMIC_ROUTE_CONFIGS: DynamicRouteConfig[] = [
  // ==================== 多级参数路由（最长路径优先） ====================

  {
    pattern: '/dashboard/orders/:id/devices/:deviceId/history',
    titleTemplate: '设备历史 #{deviceId}',
    paramNames: ['id', 'deviceId'],
    label: '设备检测历史',
    icon: Wrench,
  },

  // ==================== 单参数路由（按模块分组） ====================

  // --- 订单管理 ---
  {
    pattern: '/dashboard/orders/:id',
    titleTemplate: '订单 #{id}',
    paramNames: ['id'],
    label: '订单详情',
    icon: Package,
  },

  // --- 市场部 ---
  {
    pattern: '/dashboard/market/orders/:id/assign',
    titleTemplate: '分配订单 #{id}',
    paramNames: ['id'],
    label: '订单分配',
    icon: ClipboardList,
  },
  {
    pattern: '/dashboard/market/orders/:id',
    titleTemplate: '订单 #{id}',
    paramNames: ['id'],
    label: '市场部订单',
    icon: Package,
  },

  // --- 客服部 ---
  {
    pattern: '/dashboard/service/orders/:id/dispatch',
    titleTemplate: '派单 #{id}',
    paramNames: ['id'],
    label: '订单派单',
    icon: Truck,
  },
  {
    pattern: '/dashboard/service/orders/:id',
    titleTemplate: '订单 #{id}',
    paramNames: ['id'],
    label: '客服部订单',
    icon: Package,
  },
  // --- 工程师 ---
  {
    pattern: '/dashboard/engineer/tasks/:id',
    titleTemplate: '任务 #{id}',
    paramNames: ['id'],
    label: '工程师任务',
    icon: Wrench,
  },

  // --- 财务部 ---
  {
    pattern: '/dashboard/finance/orders/:id',
    titleTemplate: '订单 #{id}',
    paramNames: ['id'],
    label: '财务订单',
    icon: Package,
  },

  // --- 客户管理 ---
  {
    pattern: '/dashboard/customer/users/:id/orders',
    titleTemplate: '客户订单 #{id}',
    paramNames: ['id'],
    label: '客户订单列表',
    icon: User,
  },
  {
    pattern: '/dashboard/customer/users/:id',
    titleTemplate: '用户 #{id}',
    paramNames: ['id'],
    label: '用户详情',
    icon: User,
  },
  {
    pattern: '/dashboard/customer/companies/:id/customers',
    titleTemplate: '公司客户 #{id}',
    paramNames: ['id'],
    label: '公司客户列表',
    icon: Building,
  },

  // --- 我的订单（客户视角） ---
  {
    pattern: '/dashboard/my-orders/:id',
    titleTemplate: '我的订单 #{id}',
    paramNames: ['id'],
    label: '我的订单详情',
    icon: Package,
  },
]
